// extracted by mini-css-extract-plugin
module.exports = {"loginContainer":"LoginRouter_loginContainer__3feeN","container":"LoginRouter_container__2Rhl4","show":"LoginRouter_show__1mERM"};